<template>
  <div class="jump-box">
    <div class="font001" v-if="fontShow==1">快去完成 <span>{{name}}</span> 吧！<br>完成后获得更多奖励哟～</div>
    <div class="font001" v-if="fontShow==2">等一下，你还可以获得邀请奖励哟，快去邀请好友获得奖励吧～</div>
    <!--    <div class="btn001" @click="jumpFun('立即参与')">立即参与</div>-->
    <!--    <div class="btn002" @click="jumpFun('我也要邀请')">我也要邀请</div>-->
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk';

  export default {
    props: ['shareData', 'paramsData', 'tabTypeVal', 'fontShow'],
    data() {
      return {
        shareParam: {},
        name: '',
      };
    },
    watch: {
      paramsData: {
        handler: function (val, oldVal) {
          if (val) {
            let paramsOther = val.paramsOther;
            if (paramsOther) {
              let shareParam = JSON.parse(paramsOther.shareParam);
              this.shareParam = shareParam;
            }
          }
        },
        deep: true,   //true的情况下可以监听对象属性的改变(深度监听)
        immediate: true //该回调将会在侦听开始之后被立即调用(就是该组件运行的时候就调用这个方法)
      },
      tabTypeVal: {
        handler: function (val, oldVal) {
          if (val) {
            if (val == 'isRegister') {
              this.name = '新' + (this.shareParam.nodeType == 21 ? '车主' : '司机') + '注册';
            } else if (val == 'isAuth') {
              this.name = '代驾司机认证';
            } else if (val == 'isNewRushOrder') {
              this.name = '新' + (this.shareParam.nodeType == 21 ? '车主' : '司机') + '完单';
            } else if (val == 'isOldRushOrder') {
              this.name = '老' + (this.shareParam.nodeType == 21 ? '车主' : '司机') + '完单';
            } else if (val == 'allCarOwnerRushOrder') {
              this.name = '车主完单';
            } else if (val == 'allDriverRushOrder') {
              this.name = '司机完单';
            }
          }
        },
        deep: true,   //true的情况下可以监听对象属性的改变(深度监听)
        immediate: true //该回调将会在侦听开始之后被立即调用(就是该组件运行的时候就调用这个方法)
      }
    },
    created() {
    },
    methods: {
      jumpFun(val) {
        if (val == '立即参与') {
          if (this.shareParam.nodeType == 21) {
            wx.miniProgram.reLaunch({
              url: '/pages/index/index'
            });
          } else {
            this.$router.push({
              path: '/home/codeTips',
              query: {
                shareData: this.shareData ? this.shareData : null,
              }
            });
          }
        } else {
          let query = this.$route.query;
          if (this.shareParam.nodeType == 22) {
            let userInfoDjsj = this.$storage.getSession('userInfoDjsj') || {};
            let driverId = userInfoDjsj.driverId;
            query.driverId = driverId;
          }
          this.$router.push({
            path: '/home/shareUniversal',
            query: query,
          });
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .jump-box {
    text-align: center;
    padding: 32px 20px;

    .font001 {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;

      span {
        color: #FE1009;
      }
    }

    .btn001, .btn002 {
      background: linear-gradient(180deg, #FFDF88 0%, #FF8E64 25%, #FE0602 100%);
      box-shadow: 0px 4px 10px 0px #FF9E96;
      border-radius: 25px;
      font-size: 20px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 28px;
      text-shadow: 0px 2px 1px #CD0007;
      padding: 11px 0;
      margin-top: 32px;
    }

    .btn002 {
      background: linear-gradient(180deg, #FFF9D6 0%, #FFC969 100%);
      box-shadow: 0px 4px 10px 0px rgba(255, 166, 150, 0.82);
      color: #976400;
      text-shadow: 0px 2px 3px #DB7F00;
      margin-top: 24px;
    }
  }
</style>

